// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2bRSS","footer":"ModalCreateQualiphyProcedure_footer__1Pi5A","additionData":"ModalCreateQualiphyProcedure_additionData__3ZCui"};